<template>
  <div class="details" v-if="lottery">
    <div class="kaijiangjilubox">
      <h3 class="kaijiangjilu">开奖记录</h3>
      <selectedDate @changepageindex="changepageindex()" />
    </div>
    <div class="tablebox">
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        v-if="
          hisLotteryList.length > 0 &&
          addAll.length > 0 &&
          lotteryNum.length > 0
        "
      >
        <tr>
          <td width="160">时间</td>
          <td width="177">期数</td>
          <td class="btntr">
            <div
              class="btn"
              :class="flag == 'num' && 'selected'"
              @click="changeflag('num')"
            >
              显示号码
            </div>
            <div
              class="btn"
              :class="flag == 'bs' && 'selected'"
              @click="changeflag('bs')"
            >
              显示大小
            </div>
            <div
              class="btn"
              :class="flag == 'oe' && 'selected'"
              @click="changeflag('oe')"
            >
              显示单双
            </div>
          </td>
          <td colspan="3">总和</td>
        </tr>
        <tr v-for="(item, index) in hisLotteryList" :key="item.periodsId">
          <td style="font-size: 13px; font-weight: 400">
            {{ item.actualDrawingDate }}
          </td>
          <td style="font-size: 13px; font-weight: 400">
            {{ item.periodsNumber }}
          </td>
          <td>
            <!-- 号码 -->
            <ul class="table-ul" v-show="flag == 'num'">
              <li
                v-for="(num, i) in lotteryNum[index]"
                :key="'号码' + i"
                class="table-li"
              >
                <div class="table-3d-num">{{ num }}</div>
                <!-- <img class="table-num" :src="lotteryimg['touzi'+num]" alt=""> -->
              </li>
            </ul>
            <!-- 大小 -->
            <ul class="table-ul" v-show="flag == 'bs'">
              <li
                v-for="(num, i) in lotteryNum[index]"
                :key="'大小' + i"
                class="table-bs"
              >
                <div v-if="num > 4" class="bs-cheng">大</div>
                <div v-if="num <= 4" class="bs-hui">小</div>
              </li>
            </ul>
            <!-- 单双 -->
            <ul class="table-ul" v-show="flag == 'oe'">
              <li
                v-for="(num, i) in lotteryNum[index]"
                :key="'单双' + i"
                class="table-bs"
              >
                <div v-if="num % 2 == 0" class="bs-cheng">双</div>
                <div v-if="num % 2 != 0" class="bs-hui">单</div>
              </li>
            </ul>
          </td>
          <td style="font-size: 13px; font-weight: 600" width="95">
            {{ addAll[index][0] }}
          </td>
          <td :class="addAll[index][1] == '大' ? 'redtd' : 'bluetd'" width="95">
            {{ addAll[index][1] }}
          </td>
          <td :class="addAll[index][2] == '双' ? 'redtd' : 'bluetd'" width="95">
            {{ addAll[index][2] }}
          </td>
          <!-- <td>{{ addAll[index] }}</td> -->
        </tr>
      </table>
      <h2 v-else class="zanwu">暂无开奖号码</h2>
      <div class="setpage">
        <el-pagination
          :page-size="50"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import mix from "~/mixins/lotterydetails.mixins.vue";

export default {
  mixins: [mix],
  data() {
    return {
      flag: "num",
    };
  },
  methods: {
    changeflag(f) {
      this.flag = f;
    },
  },
  computed: {
    // 总和(arr[arr])
    addAll() {
      return this.$store.state.lottery.theredAddAll;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.zanwu {
  font-weight: 400;
  line-height: 26px;
  font-size: 13px;
  text-align: center;
}
.details {
  margin-top: 20px;
  width: 100%;
  background-color: #fff;
  .kaijiangjilubox {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #e7e7e7;
    .kaijiangjilu {
      padding: 10px 20px;
      line-height: 32px;
      font-size: 18px;
      font-weight: 500;
      color: #555;
      display: inline-block;
    }
  }
  .tablebox {
    padding-top: 20px;
    margin-left: 20px;
    padding-bottom: 30px;
    width: 1160px;
    .btntr {
      display: flex;
      justify-content: center;
      .btn {
        background-color: #b9b9b9;
        color: #fff;
        width: 80px;
        height: 26px;
        line-height: 26px;
        margin: 7px 5px;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
      .selected {
        background-color: #50515f;
      }
    }

    table {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      background: #e7e7e7;
      border-top: solid 1px rgb(212, 212, 212);
      border-left: solid 1px rgb(212, 212, 212);
      tr {
        height: 42px;
        td {
          border-right: solid 1px rgb(212, 212, 212);
          border-bottom: solid 1px rgb(212, 212, 212);
        }
        &:nth-child(2n) {
          background-color: #fff;
        }
        .redtd {
          font-size: 14px;
          font-weight: 600;
          color: #f12d35;
        }
        .bluetd {
          font-size: 14px;
          font-weight: 600;
          color: #184dd5;
        }
      }
    }
    .table-ul {
      display: flex;
      justify-content: center;
      height: 32px;
      .table-li {
        margin-right: 3px;
        line-height: 32px;
        width: 32px;
        height: 32px;
        margin-right: 8px;
        .table-3d-num {
          display: block;
          width: 36px;
          height: 36px;
          line-height: 36px;
          font-size: 18px;
          font-weight: 700;
          color: #000;
          text-align: center;
          background: #fafafb;
          background-image: linear-gradient(1turn, #d5d5d5 10%, #fff);
          box-shadow: 1px 3px 6px 0px rgb(0 0 0 / 50%);
          margin-right: 6px;
          border-radius: 50%;
          margin-top: -2px;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
      .table-bs {
        line-height: 32px;
        width: 32px;
        height: 32px;
        margin-right: 3px;
        .bs-cheng {
          background-color: #f9982e;
          border-radius: 4px;
          font-size: 16px;
          color: #fff;
        }
        .bs-hui {
          background-color: #7f8ab0;
          border-radius: 4px;
          font-size: 16px;
          color: #fff;
        }
      }
    }
    .setpage {
      width: 100%;
      margin-top: 28px;
      .el-pagination {
        text-align: center;
      }
    }
  }
}
</style>